import { LocateIcon, X } from "lucide-react";
import Loading from "../../../shared/Loading";
import CustomInput from "../../../shared/CustomInput";
import { useState } from "react";

const EditGuarantorLocation = ({
  closeEditGuarantorLocation,
  handleEditGuarantorLocation,
  loading,
  guarantorEditDetails,
  setGuarantorEditDetails,
}) => {
  const [showCoordinates, setShowCoordinates] = useState(false);
  const [fetchingLocation, setFetchingLocation] = useState(false);

  const getLocation = () => {
    setFetchingLocation(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setGuarantorEditDetails({
          ...guarantorEditDetails,
          residenceLatitude: position.coords.latitude,
          residenceLongitude: position.coords.longitude,
        });
        setShowCoordinates(true);
        setFetchingLocation(false);
      },
      (error) => {
        console.error("Error getting location", error);
        setFetchingLocation(false);
      },
    );
  };

  const handleChange = (field, value) => {
    setGuarantorEditDetails((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  return (
    <div
      onClick={() => closeEditGuarantorLocation()}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[900px] h-[550px] rounded-[10px] p-[20px] relative bg-white overflow-y-auto"
      >
        <div
          onClick={closeEditGuarantorLocation}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <p className="font-semibold text-[#000000] text-[16px]">
          Edit Guarantor Details
        </p>
        <p className="text-[15px] font-medium text-[#5C5C5C] mb-[20px]">
          Please update the guarantor location details below to ensure accuracy
          of your loan application.
        </p>
        <div>
          {/* Button to get current location */}
          {!showCoordinates && (
            <div className="my-4">
              <button
                onClick={getLocation}
                className="text-[#fff] bg-[#000000] text-[14px] h-[35px] flex items-center justify-center gap-[10px] rounded-[30px] px-[20px] font-medium"
                disabled={fetchingLocation}
              >
                <LocateIcon size={16} color="#fff" />
                {fetchingLocation
                  ? "Fetching location..."
                  : "Use my current location"}
              </button>
            </div>
          )}

          {/* Show inputs after location is accepted */}
          {showCoordinates && (
            <div className="w-full flex items-center gap-[20px] my-[10px]">
              <div className="flex w-[49%] flex-col">
                <label className="text-[#222222] font-medium text-[13px]">
                  Latitude
                </label>
                <CustomInput
                  placeholder="Latitude"
                  type="number"
                  value={guarantorEditDetails?.residenceLatitude || ""}
                  onChange={(e) =>
                    setGuarantorEditDetails({
                      ...guarantorEditDetails,
                      residenceLatitude: e.target.value,
                    })
                  }
                />
              </div>
              <div className="flex w-[49%] flex-col">
                <label className="text-[#222222] font-medium text-[13px]">
                  Longitude
                </label>
                <CustomInput
                  placeholder="Longitude"
                  type="number"
                  value={guarantorEditDetails?.residenceLongitude || ""}
                  onChange={(e) =>
                    setGuarantorEditDetails({
                      ...guarantorEditDetails,
                      residenceLongitude: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          )}
          <div className="flex items-start justify-between">
            <div className="w-[49%] flex flex-col">
              <label className="text-[#222222] font-medium text-[13px]">
                Location link
              </label>
              <CustomInput
                placeholder="Enter location link"
                type="text"
                value={guarantorEditDetails?.locationLink || ""}
                onChange={(e) => handleChange("locationLink", e.target.value)}
              />
            </div>
            <div className="w-[49%] flex flex-col">
              <label className="text-[#222222] font-medium text-[13px]">
                Location
              </label>
              <CustomInput
                placeholder="Enter guarantor location"
                type="text"
                value={guarantorEditDetails?.residenceLocation || ""}
                onChange={(e) =>
                  handleChange("residenceLocation", e.target.value)
                }
              />
            </div>
          </div>
        </div>
        <div className="absolute bottom-[20px] right-[20px] flex items-center justify-center gap-[10px]">
          <button
            onClick={closeEditGuarantorLocation}
            className="h-[35px] bg-[#F3F3F3] rounded-[30px] px-[15px] text-[#5C5C5C] font-medium"
          >
            Close
          </button>
          <button
            onClick={handleEditGuarantorLocation}
            disabled={loading}
            className="h-[35px] bg-[#000000] flex items-center justify-center gap-[5px] rounded-[30px] px-[15px] text-[#FFFFFF] font-medium"
          >
            {loading && <Loading />}
            Edit and Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditGuarantorLocation;
